import { render, staticRenderFns } from "./ProdutoPrincipal.vue?vue&type=template&id=38ac28e4&"
import script from "./ProdutoPrincipal.vue?vue&type=script&lang=js&"
export * from "./ProdutoPrincipal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports